import { SearchZendeskResponse } from "api-client/models/SearchZendeskResponse";
import { SearchQueryObj } from "types/search";

export enum ACTIONS {
    SEARCH_REQUEST = "COLLECTION/SEARCH_REQUEST",
    SEARCH_SUCCESS = "COLLECTION/SEARCH_SUCCESS",
    SEARCH_FAILURE = "COLLECTION/SEARCH_FAILURE",
    SEARCH_MORE_REQUEST = "COLLECTION/SEARCH_MORE_REQUEST",
    SEARCH_MORE_SUCCESS = "COLLECTION/SEARCH_MORE_SUCCESS",
    SEARCH_MORE_FAILURE = "COLLECTION/SEARCH_MORE_FAILURE",
    SET_SEARCH_QUERY = "COLLECTION/SET_SEARCH_QUERY",
}

export interface SetQuery {
    type: ACTIONS.SET_SEARCH_QUERY;
    queryObj: SearchQueryObj;
}

export interface SearchRequest {
    type: ACTIONS.SEARCH_REQUEST;
}

export interface SearchSuccess {
    type: ACTIONS.SEARCH_SUCCESS;
    payload: SearchZendeskResponse;
}

export interface SearchFailure {
    type: ACTIONS.SEARCH_FAILURE;
}

export interface SearchMoreRequest {
    type: ACTIONS.SEARCH_MORE_REQUEST;
}

export interface SearchMoreSuccess {
    type: ACTIONS.SEARCH_MORE_SUCCESS;
    payload: SearchZendeskResponse;
}

export interface SearchMoreFailure {
    type: ACTIONS.SEARCH_MORE_FAILURE;
}

export type ActionType =
    | SetQuery
    | SearchRequest
    | SearchSuccess
    | SearchFailure
    | SearchMoreRequest
    | SearchMoreSuccess
    | SearchMoreFailure;
